function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "g6"
}, React.createElement("g", {
  id: "g4"
}, React.createElement("path", {
  d: "M397.905,103.895c-17.828-31.664-38.596-56.748-61.731-74.555C310.884,9.87,283.947,0,256.112,0    c-27.832,0-54.776,9.869-80.088,29.335c-23.157,17.808-43.952,42.891-61.808,74.55c-35.116,62.258-55.255,145.092-55.255,227.26    c0,67.295,32.973,135.328,86.054,177.548l4.156,3.306h213.881l4.156-3.306c52.941-42.111,85.829-110.143,85.829-177.548    C453.038,248.954,432.943,166.125,397.905,103.895z M140.71,118.828c15.838-28.08,33.958-50.078,53.858-65.381    c19.87-15.282,40.577-23.03,61.544-23.03c20.967,0,41.66,7.747,61.509,23.026c19.876,15.299,37.969,37.295,53.78,65.376    c30.272,53.766,48.529,124.466,50.938,196.135H89.662C92.077,243.311,110.372,172.616,140.71,118.828z M352.311,481.583H159.912    c-39.965-33.682-65.885-84.471-69.956-136.211h332.088C417.995,397.198,392.156,447.987,352.311,481.583z",
  id: "path2"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "g48"
}, React.createElement("g", {
  id: "g46"
}, React.createElement("path", {
  d: "M256.112,371.331c-23.239,0-42.145,18.905-42.145,42.144s18.906,42.145,42.145,42.145    c23.239,0,42.145-18.906,42.145-42.145S279.351,371.331,256.112,371.331z M256.112,425.204c-6.467,0-11.728-5.261-11.728-11.728    c0-6.467,5.261-11.727,11.728-11.727c6.467,0,11.728,5.26,11.728,11.727S262.579,425.204,256.112,425.204z",
  id: "path44"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "g50"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "g52"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "g54"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "g56"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "g58"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "g60"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  id: "g62"
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  id: "g64"
});

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  id: "g66"
});

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  id: "g68"
});

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  id: "g70"
});

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  id: "g72"
});

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  id: "g74"
});

var _ref17 =
/*#__PURE__*/
React.createElement("g", {
  id: "g76"
});

var _ref18 =
/*#__PURE__*/
React.createElement("g", {
  id: "g78"
});

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.df5e0458.svg";
export { ForwardRef as ReactComponent };